// extracted by mini-css-extract-plugin
export default {"v_layout":"Vlayout_v_layout__AXBtl","allRightsDevelopedBy":"Vlayout_allRightsDevelopedBy__haL-m","allRights":"Vlayout_allRights__vtZ--","developedBy":"Vlayout_developedBy__DO-Tf"};